import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR, OK } from '../../utils/const/http';

const createPowerbiComment = async ({
  comment,
  powerbiReportId,
  data,
  sheet,
  deadline,
  taggedUsers,
},
) => {
  try {
    const response = await axios.post('/api/powerbi-comments', {
      comment,
      powerbiReportId,
      data,
      sheet,
      deadline,
      taggedUsers,
    });
    return {
      success: true,
      status: OK.status,
      message: OK.message,
      totalTickets: response.data,
      data: response.data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const powerbiReportRefresh = async (id) => {
  try {
    const response = await axios.get(`/api/powerbi-report/${id}/refresh`);

    return {
      success: true,
      status: OK.status,
      message: OK.message,
      data: response.data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

export default {
  createPowerbiComment,
  powerbiReportRefresh,
};
